'use client';

import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
import { cn } from '../../../shared/cn';
type DropdownMenuProps = {
  anchor?: Headless.MenuItemsProps;
  className?: string;
  style?: React.CSSProperties;
};
export function DropdownMenu(t0) {
  const $ = _c(12);
  let className;
  let props;
  let style;
  let t1;
  if ($[0] !== t0) {
    ({
      anchor: t1,
      className,
      style,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = style;
    $[4] = t1;
  } else {
    className = $[1];
    props = $[2];
    style = $[3];
    t1 = $[4];
  }
  const anchor = t1 === undefined ? "bottom" : t1;
  let t2;
  if ($[5] !== className) {
    t2 = cn("[--anchor-gap:--spacing(2)] [--anchor-padding:--spacing(1)] data-[anchor~=end]:[--anchor-offset:6px] data-[anchor~=start]:[--anchor-offset:-6px] sm:data-[anchor~=end]:[--anchor-offset:4px] sm:data-[anchor~=start]:[--anchor-offset:-4px]", "isolate w-max rounded-xl p-1", "outline outline-transparent focus:outline-hidden", "overflow-y-auto", "bg-backgroundPrimary", "border-borderPrimary border-t", "shadow-sm", "supports-[grid-template-columns:subgrid]:grid supports-[grid-template-columns:subgrid]:grid-cols-[auto_1fr_1.5rem_0.5rem_auto]", "transition data-closed:data-leave:opacity-0 data-leave:duration-100 data-leave:ease-in", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== anchor || $[8] !== props || $[9] !== style || $[10] !== t2) {
    t3 = <Headless.MenuItems {...props} transition={true} anchor={anchor} style={style} className={t2} />;
    $[7] = anchor;
    $[8] = props;
    $[9] = style;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}